import { createContext } from 'react';

// used for the copyButtons prop
const CodeOptsContext = createContext<boolean>(false);

export default CodeOptsContext;
